/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ats_Tip_Add_PhoneInputs */

const en_ats_tip_add_phone = /** @type {(inputs: Ats_Tip_Add_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a phone number to improve contact completeness`)
};

const de_ats_tip_add_phone = /** @type {(inputs: Ats_Tip_Add_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge eine Telefonnummer hinzu, um die Kontaktdaten zu vervollständigen`)
};

const fr_ats_tip_add_phone = /** @type {(inputs: Ats_Tip_Add_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajoutez un numéro de téléphone pour compléter vos coordonnées`)
};

const es_ats_tip_add_phone = /** @type {(inputs: Ats_Tip_Add_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añade un número de teléfono para mejorar la información de contacto`)
};

const it_ats_tip_add_phone = /** @type {(inputs: Ats_Tip_Add_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi un numero di telefono per completare le informazioni di contatto`)
};

const nl_ats_tip_add_phone = /** @type {(inputs: Ats_Tip_Add_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voeg een telefoonnummer toe voor betere contactvolledigheid`)
};

const pl_ats_tip_add_phone = /** @type {(inputs: Ats_Tip_Add_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dodaj numer telefonu, aby uzupełnić dane kontaktowe`)
};

const fi_ats_tip_add_phone = /** @type {(inputs: Ats_Tip_Add_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lisää puhelinnumero yhteystietojen täydentämiseksi`)
};

const da_ats_tip_add_phone = /** @type {(inputs: Ats_Tip_Add_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilføj et telefonnummer for bedre kontaktfuldstændighed`)
};

const sv_ats_tip_add_phone = /** @type {(inputs: Ats_Tip_Add_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lägg till ett telefonnummer för bättre kontaktuppgifter`)
};

/**
* | output |
* | --- |
* | "Add a phone number to improve contact completeness" |
*
* @param {Ats_Tip_Add_PhoneInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const ats_tip_add_phone = /** @type {((inputs?: Ats_Tip_Add_PhoneInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ats_Tip_Add_PhoneInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ats_tip_add_phone(inputs)
	if (locale === "fr") return fr_ats_tip_add_phone(inputs)
	if (locale === "es") return es_ats_tip_add_phone(inputs)
	if (locale === "it") return it_ats_tip_add_phone(inputs)
	if (locale === "nl") return nl_ats_tip_add_phone(inputs)
	if (locale === "pl") return pl_ats_tip_add_phone(inputs)
	if (locale === "fi") return fi_ats_tip_add_phone(inputs)
	if (locale === "da") return da_ats_tip_add_phone(inputs)
	if (locale === "sv") return sv_ats_tip_add_phone(inputs)
	return en_ats_tip_add_phone(inputs)
});